var transitionFadeInFromBottom = function transitionFadeInFromBottom(options) {
  var transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1,
          bottom: 0
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          bottom: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, bottom ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0,
          bottom: '-100%'
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, bottom ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms"),
          bottom: '-100%'
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0,
          bottom: '-100%'
        };
      }
  }
};
export { transitionFadeInFromBottom };